<template>
    <transition name="slide">
        <div
            v-if="!isStaticButtonVisible"
            class="floating"
        >
            <slot name="button"></slot>
        </div>
    </transition>

    <div
        ref="static"
        v-qa="'button-add-to-cart'"
    >
        <slot name="button"></slot>
    </div>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'
import { shallowRef, useTemplateRef } from 'vue'

const staticButton = useTemplateRef('static')
const isStaticButtonVisible = shallowRef(false)

useIntersectionObserver(staticButton, ([entry]) => {
    isStaticButtonVisible.value = entry?.isIntersecting || false
})
</script>

<style lang="scss" scoped>
.floating {
    position: fixed;
    bottom: 11.5px;
    left: 10px;
    right: 80px;
    z-index: 11;
    border-radius: 50px;
    box-shadow: 0 4px 10px rgba($black, 0.4);

    @include min-width(768) {
        display: none;
    }
}

.slide-enter-active,
.slide-leave-active,
.slide-reverse-enter-active,
.slide-reverse-leave-active {
    transition: all 175ms var(--timing-function-easing-accelerate);
}

.slide-enter-from,
.slide-reverse-leave-to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
}

.slide-leave-to,
.slide-reverse-enter-from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
}
</style>
